// extracted by mini-css-extract-plugin
export default {"container":"Collapsible_container__T06mI"};